import { Col, DatePicker, Form, Row, Table, Tag } from 'antd';
import React, { useState, useEffect } from 'react';
import dayjs from "dayjs";
import KCA_Service from '../../../../services/KCA-Service/KCA_Service';
import ResponseMessage from '../../../Comman/Notification/ResponseMessge';

const DailyReport = () => {
  const today = dayjs();
  const [form] = Form.useForm();
  const [dates, setDates] = useState([today, today]);
  const [filteredData, setFilteredData] = useState([]);
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    const featchData = async () => {
      try {
        const response = await KCA_Service.getKCA_DailyReport();
        setReportData(response.data);
        console.log(response.data);
        ResponseMessage.info(response.message)
      } catch (error) {
        console.error(error);
        ResponseMessage.error(error);
      }
    };
    featchData();
  }, [])



  const columns =
    [
      {
        key: 'gsm_m_id',
        title: 'GSM ID',
        dataIndex: 'gsm_m_id',
      },
      {
        key: 'kanban_no',
        title: 'Kanban No',
        dataIndex: 'kanban_no'
      },
      {
        title: "Size & Qty",
        dataIndex: "size_qty",
        render: (sizeQty) => {
          if (!sizeQty) {
            return <Tag color="red">No Data</Tag>;
          }

          if (typeof sizeQty === "string") {
            try {
              sizeQty = JSON.parse(sizeQty);
            } catch (error) {
              return <Tag color="red">Invalid Data</Tag>;
            }
          }

          if (typeof sizeQty !== "object" || sizeQty === null) {
            return <Tag color="red">Invalid Format</Tag>;
          }

          return Object.entries(sizeQty).map(([size, qty]) => (
            <Tag key={size} color="blue">
              {size}: {qty}
            </Tag>
          ));
        },
      },
      {
        key: 'total_qty',
        title: 'Total Qty',
        dataIndex: 'total_qty',
      },
      {
        key: 'kanban_status',
        title: 'Kanban Status',
        dataIndex: 'kanban_status',
      },
      {
        key: 'added_by',
        title: 'Added By',
        dataIndex: 'added_by',
      },
      {
        key: 'added_on',
        title: 'Added On',
        dataIndex: 'added_on',
      },
      {
        key: 'cleared_by',
        title: 'Cleared By',
        dataIndex: 'cleared_by',
      },
      {
        key: 'cleared_on',
        title: 'Cleared On',
        dataIndex: 'cleared_on',
      }
    ];

  const handleDateChange = (dateRange) => {
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      setFilteredData(reportData);
      setDates([null, null]);
      return;
    }

    setDates(dateRange);

    const fromDate = dateRange[0].format('YYYY-MM-DD');
    const toDate = dateRange[1].format('YYYY-MM-DD');

    const filtered = reportData.filter((item) => {
      const addedOn = item.added_on.split(' ')[0];
      const clearedOn = item.cleared_on.split(' ')[0];

      return (addedOn >= fromDate && addedOn <= toDate) ||
        (clearedOn >= fromDate && clearedOn <= toDate);
    });

    setFilteredData(filtered);
  };

  useEffect(() => {
    form.setFieldsValue({
      dateRange: [today, today]
    });

    handleDateChange([today, today]);
  }, []);

  return (
    <>
      <Form layout="vertical" form={form}>
        <Row gutter={[16, 16]} wrap={false} align="middle">
          <Col flex="auto">
            <Form.Item label={<strong>Select Date Range</strong>} name='dateRange'>
              <DatePicker.RangePicker
                defaultValue={[today, today]}
                value={dates}
                onChange={handleDateChange}
                style={{ width: "40%" }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="gsm_m_id"
      />
    </>
  );
};

export default DailyReport;